module.exports = __webpack_public_path__ + "fonts/ionicons.99b86349.woff";